// These helpers return updated WorkModel after removing an entity unit

import { WorkModel } from '@Entities/work/work'
import { AlternativeTitleModel } from '@Entities/work/alternative-title-model'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { WriterModel } from '@Entities/work/writer-model'
import { RecordingModel } from '@Entities/work/recording-model'

export const akaTitleRemover = (removingTitle: AlternativeTitleModel, workDraftFromLocal: WorkModel) => {
    const alternativeTitles = workDraftFromLocal.alternativeTitles

    const updatedAlternativeTitles = alternativeTitles.filter(
        (data: AlternativeTitleModel) => removingTitle.localId !== data.localId
    )

    const updatedWorkDraft: WorkModel = {
        ...workDraftFromLocal,
        alternativeTitles: updatedAlternativeTitles,
    }

    return updatedWorkDraft
}

export const writerRemover = (removingWriter: WriterModel, workDraftFromLocal: WorkModel) => {
    const writers = workDraftFromLocal.writers

    const updatedWriters = writers.filter((data: WriterModel) => removingWriter.localId !== data.localId)

    const updatedOp: OriginalPublisherModel[] = workDraftFromLocal.originalPublishers.map(
        (op: OriginalPublisherModel) => {
            const updatedWr: WriterModel[] = op.writers.filter((writer: WriterModel) => {
                if (removingWriter.id ? removingWriter.id === writer.id : removingWriter.localId === writer.localId) {
                    return
                }
                return writer
            })

            return {
                ...op,
                writers: updatedWr,
            }
        }
    )

    const updatedWorkDraft: WorkModel = {
        ...workDraftFromLocal,
        originalPublishers: updatedOp,
        writers: updatedWriters,
    }

    return updatedWorkDraft
}

export const originalPublisherRemover = (removingOP: PublisherModel, workDraftFromLocal: WorkModel) => {
    const originalPublishers = workDraftFromLocal.originalPublishers

    const updatedOP = originalPublishers.filter((data: OriginalPublisherModel) => {
        if (removingOP.localId === data.localId) {
            return
        }
        return data
    })

    const updatedWorkDraft: WorkModel = {
        ...workDraftFromLocal,
        originalPublishers: updatedOP,
    }

    return updatedWorkDraft
}

export const adminPublisherRemover = (
    removingAP: PublisherModel,
    currentOP: OriginalPublisherModel,
    workDraftFromLocal: WorkModel
) => {
    const originalPublishers = workDraftFromLocal.originalPublishers
    const administrationPublishers = currentOP.administratorPublishers
    const currentOPid = currentOP.localId

    const indexOfOP = originalPublishers.map((op: OriginalPublisherModel) => op.localId).indexOf(currentOPid)

    const updatedCurrentAP: PublisherModel[] = administrationPublishers.filter((data: PublisherModel) => {
        if (removingAP.localId === data.localId) {
            return
        }
        return data
    })

    const updatedCurrentOP: OriginalPublisherModel = {
        ...currentOP,
        administratorPublishers: updatedCurrentAP,
    }

    const updatedOPArray = setItemToArrayByIndex(originalPublishers, +indexOfOP, updatedCurrentOP)

    const updatedWorkDraft: WorkModel = {
        ...workDraftFromLocal,
        originalPublishers: updatedOPArray,
    }

    return updatedWorkDraft
}

export const recordingRemover = (removingRecording: RecordingModel, workDraftFromLocal: WorkModel) => {
    const recordings = workDraftFromLocal.recordings

    const updatedRecordings = recordings.filter((data: RecordingModel) => {
        if (removingRecording.localId === data.localId) {
            return
        }
        return data
    })

    const updatedRecordingsDraft: WorkModel = {
        ...workDraftFromLocal,
        recordings: updatedRecordings,
    }

    return updatedRecordingsDraft
}

export const setItemToArrayByIndex = (arr: any[], index: number, newItem: any) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index + 1),
]
